import {
  FilterType,
  buildExpensableGroupsDataTableFilter,
} from 'generated/resources/datatable.graphql'
import { ExpensePageFinanceCustomCategoryFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { BaseFilterProps } from './types'

type Props = BaseFilterProps & {
  categories: ExpensePageFinanceCustomCategoryFragment[]
}
const categoryFilter = ({ source, categories }: Props) => {
  const options = categories.map((cat) => ({
    label: cat.label,
    value: cat.identifier,
  }))

  return buildExpensableGroupsDataTableFilter(source, {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: options,
      },
    ],
    identifier: 'expensesList.categoryFilter',
    path: 'category',
    title: i18n.t('expenses_v2.list.header.category'),
  })
}

export default categoryFilter
